import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function About() {
  return (
    <Container className="py-5">
      <Row className="mb-5">
        <Col>
          <h2 className="text-center mb-4">About Delta</h2>
          <p className="lead text-center">
            We are a team of dedicated professionals committed to delivering excellence.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col md={6}>
          <img
            src="https://via.placeholder.com/600x400"
            alt="About Us"
            className="img-fluid rounded"
          />
        </Col>
        <Col md={6}>
          <h3>Our Story</h3>
          <p>
            Delta was founded in 2010 with a vision to provide innovative solutions to businesses
            across various industries. Over the years, we have grown into a trusted partner for
            many organizations, helping them achieve their goals through our expertise and
            dedication.
          </p>
          <p>
            Our team consists of highly skilled professionals who are passionate about what they do.
            We believe in continuous learning and staying updated with the latest technologies and
            trends to provide the best solutions to our clients.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col>
          <h3 className="text-center mb-4">Our Values</h3>
        </Col>
      </Row>

      <Row>
        <Col md={4} className="mb-4">
          <Card className="h-100">
            <Card.Body className="text-center">
              <i className="fas fa-handshake fa-3x mb-3"></i>
              <Card.Title>Integrity</Card.Title>
              <Card.Text>
                We conduct our business with the highest standards of integrity and ethics.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-4">
          <Card className="h-100">
            <Card.Body className="text-center">
              <i className="fas fa-lightbulb fa-3x mb-3"></i>
              <Card.Title>Innovation</Card.Title>
              <Card.Text>
                We constantly strive to innovate and bring new ideas to the table.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-4">
          <Card className="h-100">
            <Card.Body className="text-center">
              <i className="fas fa-users fa-3x mb-3"></i>
              <Card.Title>Collaboration</Card.Title>
              <Card.Text>
                We believe in the power of collaboration and teamwork to achieve great results.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default About;